import styles from './UgpgHero.module.css';

interface PostgraduateProgram {
    id: number;
    title: string;
    description: string;
  }

  interface Props {
    data:PostgraduateProgram
  }
const UgpgHero:React.FC<Props> = ({data}) => {
    return (
        <section className={styles.heroSection}>
            <h1 className={styles.topHeader}>{data?.title}</h1>
            <p className={styles.subHeader}>{data?.description}</p>
        </section>
    )
}

export default UgpgHero;
